module.exports = __webpack_public_path__ + "static/media/Instagram.01e730b9.svg";